module.exports = __webpack_public_path__ + "static/media/purple-candy.7d273338.png";